export const AboutController = {
    index(): void {},
    vision(): void {},
};
